import { Component, OnInit, ViewEncapsulation } from '@angular/core'
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap'

@Component({
	selector: 'app-modal-model',
	templateUrl: './modal-model.component.html',
	styleUrls: ['./modal-model.component.scss'],
	encapsulation: ViewEncapsulation.None,
})
export class ModalModelComponent implements OnInit {
	constructor(public activeModal: NgbActiveModal) {}

	ngOnInit(): void {}
	close() {
		this.activeModal.close()
	}
}
